import { redesignTheme } from '../../theme';

const { colors, fonts, fontSize, spacing, radius, sizes } = redesignTheme;

/**
 * Canonical Redesign form-field styles.
 * Spread into feature makeStyles definitions; keep Auth-specific error
 * (warning palette) and icon wrappers as local extensions.
 */
export const formFieldStyles = {
  field: {
    display: 'flex',
    flexDirection: 'column' as const,
    gap: spacing.xs,
    width: '100%',
    minWidth: 0,
  },
  label: {
    fontFamily: fonts.opensansSemiBold,
    fontSize: fontSize.md,
    color: colors.text,
  },
  input: {
    width: '100%',
    height: sizes.inputHeight,
    border: `1px solid ${colors.border}`,
    borderRadius: radius.sm,
    padding: '0 12px',
    backgroundColor: colors.white,
    fontFamily: fonts.opensans,
    fontSize: fontSize.base,
    color: colors.text,
    outline: 'none',
    boxSizing: 'border-box' as const,
    '&::placeholder': {
      color: colors.placeholder,
    },
    '&:focus': {
      borderColor: colors.primary,
    },
  },
  textarea: {
    width: '100%',
    minHeight: 98,
    border: `1px solid ${colors.border}`,
    borderRadius: radius.sm,
    padding: spacing.sm,
    backgroundColor: colors.white,
    fontFamily: fonts.opensans,
    fontSize: fontSize.base,
    color: colors.text,
    outline: 'none',
    resize: 'vertical' as const,
    boxSizing: 'border-box' as const,
    '&::placeholder': {
      color: colors.placeholder,
    },
    '&:focus': {
      borderColor: colors.primary,
    },
  },
  errorField: {
    fontFamily: fonts.opensans,
    fontSize: fontSize.sm,
    color: colors.error,
  },
  phoneField: {
    width: '100%',
    '& .PhoneInput': {
      display: 'flex',
      gap: spacing.xs,
      height: sizes.inputHeight,
    },
    '& .PhoneInputCountry': {
      height: sizes.inputHeight,
      border: `1px solid ${colors.border}`,
      borderRadius: radius.sm,
      padding: '0 12px',
      backgroundColor: colors.white,
    },
    '& .PhoneInputInput': {
      flex: 1,
      height: sizes.inputHeight,
      border: `1px solid ${colors.border}`,
      borderRadius: radius.sm,
      padding: '0 12px',
      fontFamily: fonts.opensans,
      fontSize: fontSize.base,
      backgroundColor: colors.white,
      color: colors.primaryDark,
    },
  },
  inputWrapper: {
    position: 'relative' as const,
    width: '100%',
  },
  inputWithIcon: {
    paddingRight: 36,
  },
  inputIcon: {
    position: 'absolute' as const,
    right: 12,
    top: '50%',
    transform: 'translateY(-50%)',
    width: 16,
    height: 16,
    cursor: 'pointer',
    background: 'none',
    border: 'none',
    padding: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& img': {
      width: 16,
      height: 16,
      display: 'block',
      objectFit: 'contain' as const,
    },
  },
};
